import React from 'react';
import { componentService } from 'js/services/component.service';

export const AppLaunchTimer = React.lazy(() => import(/* webpackChunkName: "app-launch-timer" */ './AppLaunchTimer'));

// <hub2-app-launch-timer format="HH:mm:ss"></hub2-app-launch-timer>
componentService.registerWebContentComponents({ AppLaunchTimer });
